import React from "react";
import { SocialPlatform, PLATFORM_CONFIG } from "./socialPlatforms";

export interface PublishButtonProps {
  label?: string;
  platform: SocialPlatform;
  isLoading: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export function PublishButton({
  label,
  platform,
  isLoading,
  onClick,
  disabled = false,
}: PublishButtonProps) {
  const config = PLATFORM_CONFIG[platform];

  return (
    <button
      type="button"
      className={config.className}
      onClick={onClick}
      disabled={disabled || isLoading}
    >
      {isLoading && (
        <span className="loading loading-spinner loading-xs mr-2"></span>
      )}
      {label ?? config.label}
    </button>
  );
}
